export const popSearchParam = (
  searchParams: URLSearchParams,
  key: string
): string | null => {
  const value = searchParams.get(key)
  searchParams.delete(key)
  return value
}
